// @flow
import type { StoreResourceDef } from 'app/core/types'

export const assetLinkTypes: StoreResourceDef<> = {
  resourceType: 'assetLinkTypes',
}
